import { pxToRem } from '../../site/js/utils/px-to-rem'

const AgendaWatermarkTitle = () => {
  const agendaWrapper = document.querySelector('.specialevent-container > .cmp-container')
  const watermarkParent = document.querySelector('.cmp-specialevent-container__triangle-watermark')
  const watermarkTitle = document.querySelector('.cmp-specialevent-container__triangle-watermark--title')
  const days = document.querySelectorAll('.day')

  const init = () => {
    if (!watermarkTitle || !agendaWrapper || days.length === 0) {
      return
    }
    window.addEventListener('load', function () {
      if (days) {
        watermarkParent.classList.remove('cmp-specialevent-container__triangle-watermark--hidden')
      }
      watermarkParent.style.height = `${pxToRem(watermarkTitle.getBoundingClientRect().height)}`
      updateWatermarkTopPosition()
      window.addEventListener('resize', function () {
        updateWatermarkTopPosition()
      })
    })
  }

  const updateWatermarkTopPosition = () => (watermarkParent.style.top = window.innerHeight * (1 / 100) + 'vh')

  document.addEventListener('DOMContentLoaded', () => {
    const CLASS_SECONDARY_BUTTON = '.cmp-button--secondary-positive'
    const CLASS_OUTER_WRAPPER = '.cmp-specialevent__outer-content-wrapper'
    const CLASS_AGENDA_WRAPPER = '.cmp-specialevent-agenda-content-wrapper'
    const CLASS_SHOW = 'show'
    const CLASS_HIDE = 'hide'
    const STYLE_BLOCK = 'block'
    const STYLE_NONE = 'none'
    const dayElements = document.querySelectorAll('.day-accordion-view .cmp-specialevent-day')

    if (dayElements.length > 0) {
      dayElements[0].classList.add('active')
    }

    dayElements.forEach(dayElement => {
      dayElement.addEventListener('click', () => {
        dayElement.classList.toggle('active')
      })
    })

    document.querySelectorAll('[data-dm="button.see-more"]').forEach(moreButton => {
      moreButton.addEventListener('click', () => {
        const outerWrapper = moreButton.closest(CLASS_OUTER_WRAPPER)
        const agendaWrapper = outerWrapper?.nextElementSibling

        if (!agendaWrapper?.classList.contains('cmp-specialevent-agenda-content-wrapper')) return

        agendaWrapper.classList.add(CLASS_SHOW)
        outerWrapper.classList.add(CLASS_HIDE)

        toggleButtons(outerWrapper, agendaWrapper, true)
      })
    })

    document.querySelectorAll('[data-dm="button.see-less"]').forEach(lessButton => {
      lessButton.addEventListener('click', () => {
        const agendaWrapper = lessButton.closest(CLASS_AGENDA_WRAPPER)
        const outerWrapper = agendaWrapper?.previousElementSibling

        if (!outerWrapper?.classList.contains('cmp-specialevent__outer-content-wrapper')) return

        agendaWrapper.classList.remove(CLASS_SHOW)
        outerWrapper.classList.remove(CLASS_HIDE)

        toggleButtons(outerWrapper, agendaWrapper, false)
      })
    })

    document.querySelectorAll('.accordionView-watermark.cmp-specialevent-container__triangle-watermark--title').forEach(watermarkSpan => {
      const sourceSpan = document.querySelector('.accordionView.cmp-specialevent-container__triangle-watermark--title');
      if (sourceSpan?.textContent) {
        watermarkSpan.textContent = sourceSpan.textContent;
      }
    });

    function toggleButtons(outerWrapper, agendaWrapper, isShown) {
      const moreButton = outerWrapper.querySelector('.cmp-button__text_more')?.closest(CLASS_SECONDARY_BUTTON)
      const lessButton = agendaWrapper.querySelector('.cmp-button__text_less')?.closest(CLASS_SECONDARY_BUTTON)

      if (moreButton) moreButton.style.display = isShown ? STYLE_NONE : STYLE_BLOCK
      if (lessButton) lessButton.style.display = isShown ? STYLE_BLOCK : STYLE_NONE
    }
  })

  const dayElements = document.querySelectorAll('.day')

  dayElements.forEach(function (dayElement) {

    const sessions = dayElement.querySelectorAll('.cmp-specialevent-agenda__content--lecture')
    const sessionCount = sessions.length

    const speakerNames = new Set()
    const speakerElements = dayElement.querySelectorAll('[data-speaker-name]')
    speakerElements.forEach(function (el) {
      const name = el.getAttribute('data-speaker-name')
      if (name && name.trim()) {
        speakerNames.add(name.trim())
      }
    })

    const speakerCount = speakerNames.size

    const sessionDiv = dayElement.querySelector('.cmp-specialevent-day__total-sessions')

    if (sessionCount != 0 && sessionDiv) {
      sessionDiv.innerHTML = `<span class="cmp_session">|</span> ${sessionCount} session${sessionCount !== 1 ? 's' : ''}`
    }

    const speakerDiv = dayElement.querySelector('.cmp-specialevent-day__total-speakers')
    if (speakerCount != 0 && speakerDiv) {
      speakerDiv.innerHTML = `<span class="cmp_speaker">|</span>  ${speakerCount} speaker${speakerCount !== 1 ? 's' : ''}`
    }
  })

  return {
    init,
  }
}
export { AgendaWatermarkTitle }
